export enum OperationTypeEnum {
  DEBIT = "DEBIT",
  DEPOSIT = "DEPOSIT",
  AUTHORIZATION = "AUTHORIZATION",
  AUTHORISATION = "AUTHORISATION",
  CHARGE = "CHARGE",
  REFUND = "REFUND",
}

export enum RoomReservationStatusEnum {
  RESERVATION = "reserva",
  PRE_RESERVATION = "prereserva",
  REACTIVATION = "reactivation",
  CANCELLED = "cancelada",
}
